import { useState, useEffect } from 'react';
import { Phone, Download, X, MessageCircle, ChevronUp } from 'lucide-react';

const FloatingMenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [canInstall, setCanInstall] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setCanInstall(true);
    };

    window.addEventListener('beforeinstallprompt', handler);

    // Check if already installed
    if (window.matchMedia('(display-mode: standalone)').matches) {
      setCanInstall(false);
    }

    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    
    if (outcome === 'accepted') {
      setCanInstall(false);
    }
    setDeferredPrompt(null);
    setIsOpen(false);
  };

  return (
    <div className="fixed bottom-6 right-6 z-50" data-testid="floating-menu">
      {/* Menu options */}
      <div className={`absolute bottom-16 right-0 flex flex-col gap-3 transition-all duration-300 ${isOpen ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'}`}>
        {/* Call button */}
        <a
          href="tel:0465011022"
          className="group flex items-center gap-3 bg-white rounded-full pl-4 pr-2 py-2 shadow-lg hover:shadow-xl transition-all"
          data-testid="floating-call"
        >
          <span className="text-stone-700 text-sm font-medium whitespace-nowrap">Appelez-nous</span>
          <div className="w-10 h-10 bg-emerald-500 rounded-full flex items-center justify-center group-hover:bg-emerald-600 transition-colors">
            <Phone className="w-5 h-5 text-white" />
          </div>
        </a>

        {/* Install app button */}
        {canInstall && (
          <button
            onClick={handleInstall}
            className="group flex items-center gap-3 bg-white rounded-full pl-4 pr-2 py-2 shadow-lg hover:shadow-xl transition-all"
            data-testid="floating-install"
          >
            <span className="text-stone-700 text-sm font-medium whitespace-nowrap">Installer l'app</span>
            <div className="w-10 h-10 bg-teal-500 rounded-full flex items-center justify-center group-hover:bg-teal-600 transition-colors">
              <Download className="w-5 h-5 text-white" />
            </div>
          </button>
        )}
      </div>

      {/* Main toggle button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`w-14 h-14 rounded-full flex items-center justify-center shadow-lg transition-all duration-300 ${
          isOpen 
            ? 'bg-stone-700 hover:bg-stone-800 rotate-0' 
            : 'bg-emerald-500 hover:bg-emerald-600 animate-bounce-subtle'
        }`}
        data-testid="floating-toggle"
      >
        {isOpen ? (
          <X className="w-6 h-6 text-white" />
        ) : (
          <MessageCircle className="w-6 h-6 text-white" />
        )}
      </button>

      {/* Pulse effect when closed */}
      {!isOpen && (
        <div className="absolute inset-0 rounded-full bg-emerald-500 animate-ping opacity-20 pointer-events-none"></div>
      )}
    </div>
  );
};

export default FloatingMenu;
